import React, { memo } from "react";
import { Pressable, StyleSheet, Text } from "react-native";
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { STRINGS } from "../constants/strings";
const tabIconSize = 26;
const HeaderBackButton = memo(({ navigation }) => (
  <Pressable
    testID="back-button"
    style={styles.backButton}
    onPress={() => (navigation.canGoBack() ? navigation.goBack() : navigation.navigate("Home"))}
    accessibilityLabel="Go back"
    accessibilityRole="button"
  >
    <FontAwesomeIcon icon={faChevronLeft} size={tabIconSize} />
    <Text style={styles.backButtonText} maxFontSizeMultiplier={1}>
      {STRINGS.back}
    </Text>
  </Pressable>
));
const styles = StyleSheet.create({
  backButton: {
    flexDirection: "row",
    marginLeft: 15,
    alignItems: "center",
  },
  backButtonText: {
    marginRight: 5,
    fontSize: 18,
  },
});
export default HeaderBackButton;
